<script lang="ts">
    import type DataProvider from '../services/data.provider'
    import type ServiceProvider from '../services/service.provider'
    import Filter from './Filter.svelte'

    export let dataProvider: DataProvider
    export let serviceProvider: ServiceProvider
</script>

<Filter {dataProvider} {serviceProvider}/>
